<section class="header">
  <div class="container-fluid">

    <div class="row d-sm-flex justify-content-between" *ngIf="!isMobile">
      <div class="justify-content-center justify-content-lg-start mb-2 mb-lg-0 col-12 col-lg-2">
        <a class="cursor-pointer brand-logo mt-1" href="" target="_self" title="Home" #navigation>
          <div>
            <svg-icon src="./assets/images/svg-icons/wsm-coin.svg" [svgStyle]="{ 'width.px': 40, 'height.px': 40 }"></svg-icon>
          </div>
          <div class="ms-1">
            <h6 class="fw-semibold m-0">WSM</h6>
            <h5 class="fw-bold m-0">CASINO</h5>
          </div>
        </a>
      </div>

      <div class="col-12 col-lg-9 d-flex justify-content-center justify-content-lg-end align-items-center"
        *ngIf="!isMobile">

        <div class="d-flex align-items-center">
          <a href="https://www.wsmcasino.com/en?overlay=auth&tab=login" class="text-decoration-none"> <button
              class="login" translate>login</button></a>
          <a href="https://www.wsmcasino.com/en?overlay=auth&tab=signup" class="text-decoration-none"> <button
              class="ms-3 connect-btn primary-btn fw-bold" translate>signup</button></a>
        </div>

        <div class="primary-outline-btn connect-btn wallet-connect-btn d-flex align-items-center ms-2" (click)="connectModal()"
          *ngIf="!walletAddress && !showBW">
          <svg-icon src="./assets/images/svg-icons/connected-dot.svg"
            [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"></svg-icon>
          <div class="ms-2" translate>connect_wallet</div>
        </div>

        <div class="primary-outline-btn connect-btn wallet-connect-btn d-flex align-items-center ms-2" (click)="connectBestWallet()"
          *ngIf="!walletAddress && showBW">
          <svg-icon src="./assets/images/svg-icons/connected-dot.svg"
            [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"></svg-icon>
          <div class="ms-2" translate>connect_bw</div>
        </div>

        <div class="primary-outline-btn connect-btn wallet-connect-btn d-flex align-items-center ms-2" (click)="disconnect()" *ngIf="walletAddress">
          <svg-icon src="./assets/images/svg-icons/connected-dot.svg"
            [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"></svg-icon>
          <div class="ms-2">{{ walletAddress | trimAddress }}</div>
        </div>

        <div class="btn-group language ms-3" dropdown>
          <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center justify-content-between">
            <img class="flag-icon" src="./assets/images/flags/{{selectedLanguage?.flag}}.svg" alt="">
            <!-- <span class="mx-1 flex-grow-1 text-black">{{ selectedLanguage?.name }}</span> -->
            <svg-icon class="dropdown" src="./assets/images/svg-icons/download.svg"
              [ngClass]="isRotated == true ?'rotated':''"></svg-icon>
          </div>
          <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
            <li class="p-2 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList"
              (click)="changeLanguage(lang.value)">
              <img src="./assets/images/flags/{{lang.flag}}.svg" alt="">
              <span>{{ lang.name }}</span>
            </li>
          </ul>
        </div>

      </div>
    </div>


    <div class="row d-flex justify-content-between" *ngIf="isMobile">
      <div class="col-12 col-lg-12 ">
        <div class="d-flex justify-content-between">
          <svg-icon src="./assets/images/svg-icons/wsm-coin.svg" [svgStyle]="{ 'width.px': 40, 'height.px': 40 }"></svg-icon>
          <div class="d-flex align-items-center ">
            <a href="https://www.wsmcasino.com/en?overlay=auth&tab=login" class="text-decoration-none"> <button
                class="login" translate>login</button></a>
            <a href="https://www.wsmcasino.com/en?overlay=auth&tab=signup" class="text-decoration-none"> <button
                class="connect-btn primary-btn ms-3 fw-bold p-0" translate>signup</button></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <div class="sticky-banner text-center py-2  header z-2">
  <a href="http://bit.ly/3QBUFiA" class="text-white">
    {{"days_until_burn"| translate: {daysUntilBurn: liveCounter?._days > 0 ? liveCounter?._days : targetDate | date: 'EEEE dd MMM'} }} 
  </a>
</div> -->